import { ChangeDetectorRef, Component } from '@angular/core';
import { LoggerService, LogPage, LogType } from '../../core/services/logger.service';
import { ProfileService } from '../../core/services/profile.service';
import { UtilityService } from '../../core/services/utility.service';
import { WidgetHostBaseComponent } from '../../shared/widget/widgethostbase.component';
import { AppComponent } from '../../app.component';

@Component({
    selector: 'app-diagnose',
    templateUrl: './diagnose.component.html',
    styleUrls: ['./diagnose.component.scss'],
    standalone: false
})
export class DiagnoseComponent extends WidgetHostBaseComponent {

    constructor(
        logger: LoggerService,
        profile: ProfileService,
        public utility: UtilityService,
        changeDetector: ChangeDetectorRef,
    ) {
        super("DiagnoseComponent", profile, logger, LogType.Page, LogPage.None, changeDetector);
    }
}
